Namespace 'Customer.Filters'

class Customer.Filters.EditFilterCustomAttributesTabView extends Backbone.View
  emptyTemplate: JST['backbone/templates/customer/filters/tabs/edit_filter_empty_custom_attributes_tab']
  className: 'filter-custom-attributes-container'

  initialize: ({customAttributes, filter, editable}) ->
    @fixedStringCustomAttributes = customAttributes.tags
    @hierarchicalTagsCustomAttributes = customAttributes.hierarchical_tags
    @filter = filter
    @editable = editable

  render: ->
    @$el.empty()
    @fixedStringAttributeViews = []
    @hierarchicalTagsAttributeViews = []

    if @fixedStringCustomAttributes.length == 0 && @hierarchicalTagsCustomAttributes.length == 0
      return @_renderEmptyTemplate()

    @addFixedStringAttributeViews()
    @addHierarchicalTagsAttributeViews()
    @_renderAttributeViews()
    @

  addFixedStringAttributeViews: =>
    @_addAttributeViews
      attributes: @fixedStringCustomAttributes
      viewClass: Customer.Filters.EditCustomAttributes.EditFixedStringView
      viewArray: @fixedStringAttributeViews

  addHierarchicalTagsAttributeViews: =>
    @_addAttributeViews
      attributes: @hierarchicalTagsCustomAttributes
      viewClass: Customer.Filters.EditCustomAttributes.EditHierarchicalTagsView
      viewArray: @hierarchicalTagsAttributeViews

  _addAttributeViews: ({attributes, viewClass, viewArray}) =>
    attributes.forEach (attribute) =>
      attributeView = new viewClass
        customAttribute: attribute
        filter: @filter
        editable: @editable
        id: 'filter-custom_attributes-tags-' + attribute.code
      viewArray.push(attributeView)

  _renderAttributeViews: =>
    attributeViews = _.union(@fixedStringAttributeViews, @hierarchicalTagsAttributeViews)
    attributeViews = _.sortBy(attributeViews, (view) -> view.customAttribute.order)
    @$el.append(view.render().el) for view in attributeViews

  _renderEmptyTemplate: =>
    @$el.html @emptyTemplate
    @

  updateCustomAttributeTags: =>
    @filter.updateCustomAttributeTags(
      @fixedStringAttributeViews.map((view) -> view.getValuesForFilter())
    )
    @filter.updateCustomAttributeHierarchicalTags(
      @hierarchicalTagsAttributeViews.map((view) -> view.getValuesForFilter())
    )
